export const LAST_PATCH_NOTES_USER = {
  es: `
### Versión 6.20 (03/11/2026)
* Errores HTTP:
  - Añadidos mensajes de error faltantes.
* Navegación:
  - Actualizado control de navegación al cambiar los selectores de cliente/entidad/agrupación para evitar errores de carga.
* Sensórica -> Mapa interactivo de fugas:
  - Actualizado color por encima de filtro para distinguirlo de las posibles alarmas.
  - Añadido dato de rango en popup de mapa.
* Análisis de datos -> Balances -> Nuevo:
  - Corregido un error por el que al crear un nuevo balance desde una selección previa de contadores, éstos no se añadían automáticamente al balance como hijos.
* Dispositivo -> Detalle:
  - Corregido un error en la gráfica de consumo por el que si se buscaban datos con un tipo de gráfica seleccionado, no se mostraban las alarmas.
  - Añadida pestaña de datos extra.
* Mapas:
  - Añadida opción de selección de dispositivos a partir de todos los polígonos cargados.
* Dispositivo -> Nuevo:
  - Actualizada estructura y estilos de formulario.
* Cliente/Entidad/Agrupación:
  - Actualizada estructura y estilos de formulario.
* Ficheros de salida:
  - Actualizada estructura y estilos de formularios.
* Usuarios -> Formulario:
  - Actualizada estructura y estilos de formulario.
* Datos customizados -> Listado de CUPS:
  - Corregido un error en la creación de nuevo CUPS que añadía campos incorrectos al formulario.
* Dispositivo -> Listados -> Sustituciones pendientes:
  - Corregida columna de último valor.
`,
  en: `
### Version 6.20 (03/11/2026)
* HTTP Errors:
  - Added missing error messages.
* Navigation:
  - Updated navigation control when changing client/entity/grouping selectors to prevent loading errors.
* Sensors -> Interactive Leak Map:
  - Updated the color of the filter overlay to distinguish it from potential alarms.
  - Added range information to the map pop-up.
* Data Analysis -> Balances -> New:
  - Fixed an issue where, when creating a new balance from a previously selected set of meters, the meters were not automatically added to the balance as child elements.
* Device -> Details:
  - Fixed an issue in the consumption chart where alarms would not appear when searching for data with a specific chart type selected.
  - Added an "extra data" tab.
* Maps:
  - Added an option to select devices based on all loaded polygons.
* Device -> New:
  - Updated form structure and styles.
* Client/Entity/Grouping:
  - Updated form structure and styles.
* Output Files:
  - Updated form structure and styles.
* Users -> Form:
  - Updated form structure and styles.
* Custom Data -> CUPS List:
  - Fixed an issue in the creation of a new CUPS entry that caused incorrect fields to be added to the form.
* Device -> Lists -> Pending substitutions:
  - Fixed the "last value" column.
  `,
  "es-ca": null,
  fr: null,
  it: null,
  el: null
};
